// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

/* Layout */
.assessment-dashboard {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: var(--Neutral-50, #F8FAFC);
  box-sizing: border-box;
}

/* Main content area fills remaining height but still scrolls with page */
.maincontentarea-assessment {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--Neutral-50, #F8FAFC);
  width: 100%;
  flex: 1 1;
  /* fills remaining space */
  padding-bottom: 1.5rem;
  box-sizing: border-box;
}

.termsOfServiceDemo {
  display: flex;
  margin-block: 2rem;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
  padding: 0 5%;
  height: auto;
  flex-wrap: wrap;
  margin-top: auto;
  font-family: Inter, sans-serif;
  font-size: 12px;
  color: #64748B;
  box-sizing: border-box;
}

.termsOfServiceDemo>p {
  color: #64748B;
  font-family: var(--Body-Small-Font, Roboto);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  margin: 0;
}

.termsOfServiceDemo>a {
  color: #334155;
  font-family: var(--Body-Small-Font, Roboto);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-decoration: underline;
  cursor: pointer;
}

.terms-and-privacy-link-text {
  color: #0a66c2; /* same as before or replace with your preferred blue */
  text-decoration: none;
  cursor: pointer;
  font-weight: 700;
}


@media (max-width: 480px) {
  /* .termsOfServiceDemo {
    display: none;
  } */
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Assessment-dashboard/Assessment-dashboard.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,SAAO;EACP,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,uDAAuD;EACvE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE;;KAEG;AACL","sourcesContent":["html,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n/* Layout */\n.assessment-dashboard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-height: 100vh;\n  background: var(--Neutral-50, #F8FAFC);\n  box-sizing: border-box;\n}\n\n/* Main content area fills remaining height but still scrolls with page */\n.maincontentarea-assessment {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  background: var(--Neutral-50, #F8FAFC);\n  width: 100%;\n  flex: 1;\n  /* fills remaining space */\n  padding-bottom: 1.5rem;\n  box-sizing: border-box;\n}\n\n.termsOfServiceDemo {\n  display: flex;\n  margin-block: 2rem;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n  width: 100%;\n  padding: 0 5%;\n  height: auto;\n  flex-wrap: wrap;\n  margin-top: auto;\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  color: #64748B;\n  box-sizing: border-box;\n}\n\n.termsOfServiceDemo>p {\n  color: #64748B;\n  font-family: var(--Body-Small-Font, Roboto);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  margin: 0;\n}\n\n.termsOfServiceDemo>a {\n  color: #334155;\n  font-family: var(--Body-Small-Font, Roboto);\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  letter-spacing: 0.4px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.terms-and-privacy-link-text {\n  color: #0a66c2; /* same as before or replace with your preferred blue */\n  text-decoration: none;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n\n@media (max-width: 480px) {\n  /* .termsOfServiceDemo {\n    display: none;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
